<template>
  <div
    v-if="items.length"
    class="toast-stack"
    role="region"
    aria-label="Notifications"
  >
    <transition-group name="toast" tag="div">
      <div
        v-for="t in items"
        :key="t.id"
        :class="['toast', `toast--${t.type}`]"
        role="alert"
      >
        <p class="toast__message" v-text="t.message"></p>
        <div class="toast__actions">
          <button
            v-if="t.action"
            type="button"
            class="toast__action"
            @click="handleAction(t)"
            v-text="t.action.label"
          ></button>
          <button
            type="button"
            class="toast__close"
            aria-label="Dismiss"
            @click="dismiss(t.id)"
          >
            &times;
          </button>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: "Toast",
};
</script>

<script setup>
import {computed} from "vue";
import {useStore} from "vuex";

const store = useStore();
const items = computed(() => store.state.toast?.items || []);

const dismiss = id => store.dispatch("toast/dismiss", id);

const handleAction = t => {
  if (t.action?.type === "refresh") {
    window.location.reload();
    return;
  }
  if (t.action?.href) {
    window.location.href = t.action.href;
    return;
  }
  dismiss(t.id);
};
</script>
